module.exports = __webpack_public_path__ + "img/phone.ede9a108.png";